/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum NotificationMessageType {
  None = 0,
  BookingArrangement = 1,
  Notice = 2,
  Warning = 3,
  Deviation = 4,
  Information = 5,
  Cancellation = 6,
  BookingConfirmation = 7,
  OnlineBookingArrangement = 8,
}
